import { render, staticRenderFns } from "./ResponseToMessage.vue?vue&type=template&id=b0347e4c&"
import script from "./ResponseToMessage.vue?vue&type=script&lang=js&"
export * from "./ResponseToMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports